import type { ReactNode } from 'react';
import './FormField.css';

export interface FormFieldProps {
  label: string;
  htmlFor: string;
  required?: boolean;
  error?: string;
  children: ReactNode;
}

/**
 * Label + input/textarea + optional error message wrapper.
 * `error` is rendered with `role="alert"` for screen-reader announcement
 * per the Accessibility AA requirement.
 */
export function FormField({ label, htmlFor, required, error, children }: FormFieldProps) {
  return (
    <div className="dma-form-field">
      <label htmlFor={htmlFor} className="dma-form-field__label">
        {label}
        {required ? (
          <span aria-hidden="true" className="dma-form-field__required">
            {' '}
            *
          </span>
        ) : null}
      </label>
      {children}
      {error ? (
        <p className="dma-form-field__error" role="alert">
          {error}
        </p>
      ) : null}
    </div>
  );
}
